import { Button } from '@material-ui/core';
import React from 'react';
import { useDebounce } from '../../hooks';

const ActionButtons = ({onEdit, onDelete, onCancel, className}) => {

  const handleCancel = useDebounce((data) => {
    onCancel();
  }, 1000);

  const handleEdit = useDebounce((data) => {
    onEdit();
  }, 1000);

  const handleDelete = useDebounce((data) => {
    onDelete();
  }, 1000);

  return (
    <>
      { onCancel &&
        <Button style={{ marginRight: '2em' }}  className={className?className:''} variant="outlined" color="primary" onClick={() => handleCancel()}>
          Back
        </Button>
      }
      { onEdit &&
        <Button variant="contained" className={className?className:''} color="primary" onClick={() => handleEdit()}>
          Edit
        </Button>
      }
      { onDelete &&
        <Button variant="contained"  className={className?className:''} color="primary" onClick={() => handleDelete()}>
          Delete
        </Button>
      }
    </>
  );
};

export default ActionButtons;
